<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <el-menu
      v-loading="loading"
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#304156"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
      >
      <sidebar-item :routes="routes"></sidebar-item>
    </el-menu>
    <perm-tree
      v-show="false"
      base="adminRole"
      ref="perm"
      >
    </perm-tree>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import PermTree from '@/components/PermTree'

export default {
  components: { SidebarItem, PermTree },
  data () {
    return {
      loading: false,
      pathMap: {},
      routes: []
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'perms'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    }
  },
  mounted () {
    this.loading = true
    this.$store.dispatch('FetchMePerm').then(data => {
      data.routes.forEach(r => {
        this.$refs.perm.setTreeChecked(r.method + ' ' + r.path)
      })

      this.$refs.perm.getAllChecked().forEach(c => {
        if (c.isBase) {
          this.pathMap[c.path] = true
        }
      })

      let routes = JSON.parse(JSON.stringify(this.$router.options.routes))
      routes.forEach(e => {
        this.setByPerm(e)
      })
      this.routes = routes
      if (process.env.NODE_ENV === 'development') {
        this.$refs.perm.checkPathExists()
      }
    }).catch(err => {
      console.log(err)
    }).then(() => {
      this.loading = false
    })
  },
  methods: {
    setByPerm (e) {
      if (e.hidden) {
        return
      }
      if (!this.pathMap[e.path] && e.path !== 'list') {
        e.hidden = true
        return
      }
      if (e.children) {
        e.children.forEach(c => {
          this.setByPerm(c)
        })
      }
    }
  }
}
</script>
